import React from "react";
import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import currencyData from "cldr-core/supplemental/currencyData.json";
import weekData from "cldr-core/supplemental/weekData.json";

import number from "cldr-numbers-full/main/pt/numbers.json";
import localCurrency from "cldr-numbers-full/main/pt/currencies.json";
import caGregorian from "cldr-dates-full/main/pt/ca-gregorian.json";
import dateFields from "cldr-dates-full/main/pt/dateFields.json";

import { IntlProvider, load, loadMessages, LocalizationProvider } from "@progress/kendo-react-intl";

const traducao = {
  datepicker: {
    toggleCalendar: "Alternar Calendário"
  },
  datetimepicker:{
    set: "OK",
    cancel: "Cancelar",
    now: "Agora",
    date: "Data",
    time: "Tempo"
  },
  calendar: {
    today: "Hoje",
    now: "Agora"
  },
  timepicker: {
    toggleCalendar: "Alternar Tempo",
    now: "Agora"
  },
  dateinput: {
    increment: "Incrementar",
    decrement: "Disminuir"
  },
  editor: {
    bold: "Negrito",
    italic: "Itálico",
    underline: "Sublinhado",
    undo: "Desfazer",
    redo: "Refazer",
    hyperlink: "Inserir Link",
    "editor.hyperlink-dialog-cancel": "Cancelar",
    alignLeft: "Alinhar à Esquerda",
    alignCenter: "Alinhar ao Centro",
    alignRight: "Alinhar à Direita",
    alignJustify: "Justificar",
    indent: "Identar",
    outdent: "Remover Identação",
    orderedList: "Inserir Lista Ordenada",
    bulletList: "Inserir Lista",
    fontSize: "Tamanho Fonte",
    fontName: "Fonte",
    format: "Formatar"
  },
  grid: {

    //Doc: https://www.telerik.com/kendo-react-ui/components/grid/globalization/#toc-internationalization

    groupPanelEmpty: "Arraste um cabeçalho de coluna e solte-o aqui para agrupar por essa coluna",
    pagerItemsPerPage: "itens por página",
    pagerInfo: '{0} - {1} de {2} itens',
    pagerFirstPage: 'Ir para primeira página',
    pagerPreviousPage: 'Ir para a página anterior',
    pagerNextPage: 'Ir para próxima página',
    pagerLastPage: 'Ir para última página',
    pagerPage: 'Página',
    pagerOf: 'de',

    filterClearButton: 'Limpar',
    filterEqOperator: 'É igual a',
    filterNotEqOperator: 'Diferente de',
    filterIsNullOperator: 'É nulo',
    filterIsNotNullOperator: 'Não é nulo',
    filterIsEmptyOperator: 'É vazio',
    filterIsNotEmptyOperator: 'Não é vazio',
    filterStartsWithOperator: 'Começa com',
    filterContainsOperator: 'Contém',
    filterNotContainsOperator: 'Não contém',
    filterEndsWithOperator: 'Termina com',
    filterGteOperator: 'É maior ou igual a',
    filterGtOperator: 'É maior que',
    filterLteOperator: 'É menor ou igual a',
    filterLtOperator: 'É menor que',
    filterIsTrue: 'É verdadeiro',
    filterIsFalse: 'É falso',
    filterBooleanAll: '(Todos)',
    filterAfterOrEqualOperator: 'Após ou igual a',
    filterAfterOperator: 'Após',
    filterBeforeOperator: 'Antes',
    filterBeforeOrEqualOperator: 'Antes ou igual a',

    noRecords: 'Não há registros disponíveis'


  }
};

load(likelySubtags, currencyData, weekData, number, localCurrency, caGregorian, dateFields);
loadMessages(traducao, "pt");

class LocalizationProviderComponent extends React.Component {
  render() {
    return (
      <LocalizationProvider language="pt">
        <IntlProvider locale="pt">{this.props.children}</IntlProvider>
      </LocalizationProvider>
    );
  }
}

export default LocalizationProviderComponent;
